import { IntlShape } from 'react-intl';
import { ModuleHierachy } from '../../common/module/types';
import { isPermitted } from 'src/app/common/utils';
import {
  AdminSimulationToolPermissionType,
  CRITERIA_NAMESPACE,
  CRITERIA_PATH,
  CRITERIA_TITLE,
  NOTE_NAMESPACE,
  NOTE_PATH,
  NOTE_TITLE,
  PARAMETER_NAMESPACE,
  PARAMETER_PATH,
  PARAMETER_TITLE,
  SIMULATION_TOOL_PATH,
  SIMULATION_TOOL_TITLE,
} from './constants';
import CriteriaManagementPage from './pages/CriteriaSetting/CriteriaSettingManagementPage';
import ParameterManagementPage from './pages/ParameterSetting/ParameterSettingManagementPage';
import NoteManagementPage from './pages/NoteSetting/NoteSettingManagementPage';

export const simulationToolModuleConfig = (permissions: string[], intl: IntlShape): ModuleHierachy => {
  const Translation = (id: string) => intl.formatMessage({ id });
  return {
    title: Translation(SIMULATION_TOOL_TITLE),
    path: SIMULATION_TOOL_PATH,
    icon: '/media/svg/icons/Media/Equalizer.svg',
    enableRead: isPermitted(Object.values(AdminSimulationToolPermissionType), permissions),
    child: [
      {
        title: Translation(CRITERIA_TITLE),
        path: `${SIMULATION_TOOL_PATH}${CRITERIA_PATH}`,
        namespace: CRITERIA_NAMESPACE,
        component: CriteriaManagementPage,
        enableRead: isPermitted(
          [
            AdminSimulationToolPermissionType.CRITERIA_READ,
            AdminSimulationToolPermissionType.CRITERIA_CREATE,
            AdminSimulationToolPermissionType.CRITERIA_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([AdminSimulationToolPermissionType.CRITERIA_CREATE], permissions),
        enableUpdate: isPermitted([AdminSimulationToolPermissionType.CRITERIA_UPDATE], permissions),
      },
      {
        title: Translation(PARAMETER_TITLE),
        path: `${SIMULATION_TOOL_PATH}${PARAMETER_PATH}`,
        namespace: PARAMETER_NAMESPACE,
        component: ParameterManagementPage,
        enableRead: isPermitted(
          [
            AdminSimulationToolPermissionType.PARAMETER_READ,
            AdminSimulationToolPermissionType.PARAMETER_CREATE,
            AdminSimulationToolPermissionType.PARAMETER_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([AdminSimulationToolPermissionType.PARAMETER_CREATE], permissions),
        enableUpdate: isPermitted([AdminSimulationToolPermissionType.PARAMETER_UPDATE], permissions),
      },
      {
        title: Translation(NOTE_TITLE),
        path: `${SIMULATION_TOOL_PATH}${NOTE_PATH}`,
        namespace: NOTE_NAMESPACE,
        component: NoteManagementPage,
        enableRead: isPermitted(
          [
            AdminSimulationToolPermissionType.NOTE_READ,
            AdminSimulationToolPermissionType.NOTE_CREATE,
            AdminSimulationToolPermissionType.NOTE_UPDATE,
          ],
          permissions,
        ),
        enableCreate: isPermitted([AdminSimulationToolPermissionType.NOTE_CREATE], permissions),
        enableUpdate: isPermitted([AdminSimulationToolPermissionType.NOTE_UPDATE], permissions),
      },
    ],
  };
};
